import React from 'react';
import Text from './Text';

import { useAppSelector } from '../app/hooks';
import getThemeLookup from '../selectors/getThemeLookup';
import combineStyles from '../utils/combineStyles';
import { TEXT_PROPERTIES } from '../utils/theme';

export default function HorizontalLine({
  text,
  clippingBackgroundColor,
}: {
  text?: string;
  clippingBackgroundColor?: string;
}) {
  const p = useAppSelector(getThemeLookup);

  return (
    <div
      style={combineStyles(styles.horizontalLine, {
        background: p('defaultBorder', ['borderColor']).borderColor,
      })}
    >
      <Text
        style={combineStyles(styles.horizantalText, p('horizontalLineText', TEXT_PROPERTIES), {
          background: clippingBackgroundColor || p('screen', ['backgroundColor']).backgroundColor,
        })}
      >
        {text}
      </Text>
    </div>
  );
}

const styles: Styles = {
  horizontalLine: {
    position: 'relative',
    height: 1,
    width: '100%',
    margin: '1em 0',
  },
  horizantalText: {
    translate: '0 -50%',
    fontFamily: 'Arial, Helvetica, sans-serif',
    position: 'absolute',
    paddingLeft: 10,
    paddingRight: 10,
    left: '50%',
    transform: 'translate(-50%, 0)',
  },
};
